import React from 'react';
import useNotifications from './hooks/useNotifications';

export default function withNotifications(Component) {
  return props => {
    const [notifications, addNotification] = useNotifications();

    return <Component notifications={notifications} addNotification={addNotification} {...props} />;
  };
}



// WEBPACK FOOTER //
// ../ui-components/components/MapNotifications/withNotifications.jsx